import React from "react";
import PropTypes from "prop-types";

import RequestDemoForm from "./RequestDemoForm";
import FacilityReferralForm from "./FacilityReferralForm";
import NewsletterSubscriptionForm from "./NewsletterSubscriptionForm";
import ProfessionalInfoForm from "./ProfessionalInfoForm";
import WhitePaperForm from "./WhitePaperForm";
import TextMeTheAppForm from "./TextMeTheAppForm";
import GuardedDownloadForm from "./GuardedDownloadForm";
import CSUReferralForm from "./CSUReferralForm";
import LaborSavingsReportForm from "./LaborSavingsReportForm";
import CMSDashboardAccessForm from "./CMSDashboardAccessForm";

const ContentForm = ({
    formType,
    theme,
    variant,
    lead,
    submitButtonLabel,
    successMessage,
    submittedFormLink,
    headerForm,
    source,
}) => {
    if (formType === "Request demo") {
        return (
            <RequestDemoForm
                lead={lead}
                successMessage={successMessage}
                headerForm={headerForm}
                submitButtonLabel={submitButtonLabel}
                theme={theme}
                source={source}
            />
        );
    }

    if (formType === "Facility referral") {
        return (
            <FacilityReferralForm lead={lead} successMessage={successMessage} />
        );
    }

    if (formType === "Text me the app") {
        return (
            <TextMeTheAppForm
                successMessage={successMessage}
                lead={lead}
                prefix="header"
                variant={variant}
                className={variant}
            />
        );
    }

    if (formType === "Newsletter subscription form") {
        return (
            <NewsletterSubscriptionForm
                lead={lead}
                successMessage={successMessage}
            />
        );
    }

    if (formType === "Guarded Download") {
        return (
            <GuardedDownloadForm lead={lead} successMessage={successMessage} />
        );
    }

    if (formType === "White Paper Form") {
        return (
            <WhitePaperForm
                lead={lead}
                successMessage={successMessage}
                submittedFormLink={submittedFormLink}
                submitButtonLabel={submitButtonLabel}
            />
        );
    }

    if (formType === "Professional Info") {
        return (
            <ProfessionalInfoForm
                lead={lead}
                submittedFormLink={submittedFormLink}
                successMessage={successMessage}
            />
        );
    }

    if (formType === "CSU Referral") {
        return <CSUReferralForm />;
    }

    if (formType === "Labor Savings Report Form") {
        return (
            <LaborSavingsReportForm
                lead={lead}
                successMessage={successMessage}
                submitButtonLabel={submitButtonLabel}
                variant={variant}
                source={source}
            />
        );
    }

    debugger;

    if (formType === "CMS Dashboard Access Form") {
        return <CMSDashboardAccessForm />;
    }

    return null;
};

ContentForm.propTypes = {
    theme: PropTypes.string,
    lead: PropTypes.shape({ raw: PropTypes.string }),
    successMessage: PropTypes.shape({ raw: PropTypes.string }),
    formType: PropTypes.string.isRequired,
    styleType: PropTypes.string,
    headerForm: PropTypes.bool,
    source: PropTypes.string,
};

export default ContentForm;
